import React from "react";
import { bool, node } from "prop-types";
import { Col } from "../Grid";

const GuidePageTemplateMain = ({ sidebar = true, children, ...props }) => {
	const responsiveProps = sidebar
		? {
				auto: true,
		  }
		: {
				lg: 9,
		  };
	return (
		<Col {...responsiveProps} {...props}>
			{children}
		</Col>
	);
};

GuidePageTemplateMain.propTypes = {
	sidebar: bool,
	children: node.isRequired,
};

export default GuidePageTemplateMain;
